module.exports = __webpack_public_path__ + "img/vertical-logo-strip.c3700814.png";